<template>
  <div class="interview-practice-container">
    <chatbot-component />
  </div>
</template>

<script>
import ChatbotComponent from './ChatbotComponent.vue'

export default {
  name: 'InterviewPractice',
  components: {
    ChatbotComponent
  },
  data () {
    return {
      formSubmitted: false,
      companyInfo: '',
      motivation: ''
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.interview-practice-container {
    margin: 0 auto;
}

h1 {
    text-align: center;
    margin-bottom: 20px;
}
</style>
